import React from 'react';
import IO from 'us.collection.input-output';

export default () => {
    return (
        <IO.Components.ManageMapFiles.Home />
    )
}